export default __webpack_public_path__ + "static/media/excel_green.c0dcb7a7.svg";